/**
 * Checks if a node should be excluded from processing (e.g., text nodes in script tags).
 * @param {Node} node
 * @returns {boolean}
 */
export function isExcludedNode(node) {
  const parent = node.parentElement;
  if (!parent) return true;
  if (parent.closest('.a11y-sidebar, .a11y-reading-window, .a11y-semantic-overlay, .a11y-focus-path')) return true;
  const tag = parent.tagName;
  return ['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'CODE', 'PRE', 'SVG'].includes(tag);
}

/**
 * Checks if an element is a readable block of text.
 * @param {HTMLElement} el
 * @returns {boolean}
 */
export function isReadableBlock(el) {
  if (!el || el.nodeType !== 1) return false;
  if (el.closest('.a11y-sidebar, .a11y-reading-window, .a11y-semantic-overlay, .a11y-focus-path')) return false;
  const tag = el.tagName;
  if (['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'BUTTON', 'NAV', 'HEADER', 'FOOTER', 'ASIDE'].includes(tag)) return false;
  
  const text = el.textContent ? el.textContent.trim() : '';
  if (text.length < 40) return false;
  
  const style = window.getComputedStyle(el);
  return style.display === 'block' || style.display === 'list-item';
}

/**
 * Finds the nearest readable block ancestor or self.
 * @param {HTMLElement} target
 * @returns {HTMLElement|null}
 */
export function findReadableBlock(target) {
  let el = target;
  while (el && el !== document.body) {
    if (isReadableBlock(el)) return el;
    el = el.parentElement;
  }
  return null;
}
